module.exports = __webpack_public_path__ + "static/img/security02.14ab8b3e.png";